
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as build0lCHodXmJjSx8gfrpjHl6J8l_jpUw3TCU5_F8c4GIHYMeta } from "/opt/apps/transkribus_app_beta/pages/build.vue?macro=true";
import { default as guideBso2ycYVafIzsqoQSvwsWKiOgMq2AQfVu1SGJDXnxBcMeta } from "/opt/apps/transkribus_app_beta/pages/guide.vue?macro=true";
import { default as indexfSDzduOPa653ICfdhPk_KHPbRPgrvDW2qcaVye9W16YMeta } from "/opt/apps/transkribus_app_beta/pages/index.vue?macro=true";
import { default as login8LO5ET6UGov1saxNYLsmkvzVrT0srajZZ6ryMiUkxt0Meta } from "/opt/apps/transkribus_app_beta/pages/login.vue?macro=true";
import { default as changelog7owxKjZgIRKXciyXGubOVpQCA3WPqrdvWMtLn9gJ9A4Meta } from "/opt/apps/transkribus_app_beta/pages/changelog.vue?macro=true";
import { default as map3yj0thrqZWsqNc9CkOiVTQKF1QPuOMpaTt7tBJdnIoEMeta } from "/opt/apps/transkribus_app_beta/pages/sites/map.vue?macro=true";
import { default as indexMFRmy3hCtp04_H6VifkeKG2KvpZuhnsEK_oPZz_7Z2oMeta } from "/opt/apps/transkribus_app_beta/pages/jobs/index.vue?macro=true";
import { default as indexGxFG_0znRyzW1065yTwbwBeSNhA7kwcyNNLCKhMn5ggMeta } from "/opt/apps/transkribus_app_beta/pages/learn/index.vue?macro=true";
import { default as indexLwl5ztTjrBMum4Oe0iFZ6a2EjyRHGm6was6wER8z14kMeta } from "/opt/apps/transkribus_app_beta/pages/sites/index.vue?macro=true";
import { default as indexDjatYhnlnsRYn7ql_mnqmQNJppV_sGEpJUAIAs87bfIMeta } from "/opt/apps/transkribus_app_beta/pages/usage/index.vue?macro=true";
import { default as indexazCZd_1rdVm2YsN9UXz1Ab6QLOFpEYWevo8sr7keI4cMeta } from "/opt/apps/transkribus_app_beta/pages/models/index.vue?macro=true";
import { default as indexS4q9sapgMfWYn0HV03HUyIDbC7aNrl9mDrmhLARBHAUMeta } from "/opt/apps/transkribus_app_beta/pages/search/index.vue?macro=true";
import { default as create5FNN3tw6yUYQYkW91M1pOLvU97iD9DN68U8zwi_BRh0Meta } from "/opt/apps/transkribus_app_beta/pages/sites/create.vue?macro=true";
import { default as indexjedlQIF37A5hQLzsyI5Y5Ea3CcQSHzOMB3Ats1FQvb8Meta } from "/opt/apps/transkribus_app_beta/pages/upload/index.vue?macro=true";
import { default as indexEWLSuZx2StnwLTn6L7d0oLo0LQ3BbIa9SJor04ljeSEMeta } from "/opt/apps/transkribus_app_beta/pages/version/index.vue?macro=true";
import { default as indexNT3a2eHidG_5GdPcdbmMgHmFQIBCgnUcQcIp0HfktvIMeta } from "/opt/apps/transkribus_app_beta/pages/welcome/index.vue?macro=true";
import { default as indexBaJiRAzJZXS3qeBHqc193TiQL4M5ZtDHnH5QTIxMl6cMeta } from "/opt/apps/transkribus_app_beta/pages/data-lab/index.vue?macro=true";
import { default as indexOVE7BDFuc6bZ1iPXH23U_6OWUtZd8FUeC_MRGegvwaoMeta } from "/opt/apps/transkribus_app_beta/pages/datasets/index.vue?macro=true";
import { default as indexJLjU4hD7rw89FYFJSKAlLjBYmwGP8cnUA8Obrinkr_MMeta } from "/opt/apps/transkribus_app_beta/pages/projects/index.vue?macro=true";
import { default as indexFRnpCciRCOlNJngOgnEIAh_eKwKLpjaJobXyO0kFqb0Meta } from "/opt/apps/transkribus_app_beta/pages/collection/index.vue?macro=true";
import { default as indexvODCCl1VhMpQmRq67m57uno_I6qMDjSZOWcckMPcRmoMeta } from "/opt/apps/transkribus_app_beta/pages/invitations/index.vue?macro=true";
import { default as indexDOO9PmWFRjDTPJVpwbWnQsHmnOZe5i9dv_FvuRfd_EsMeta } from "/opt/apps/transkribus_app_beta/pages/sites/[url]/index.vue?macro=true";
import { default as index0bPy4prxDNEwJMvIsUqY3HLdkdZ5VJZSyQiJ35_J0fUMeta } from "/opt/apps/transkribus_app_beta/pages/activity/all/index.vue?macro=true";
import { default as admin_45slugsstvhNIdAfGhstG0g04KIbW1RQDcRSq3hOgFRl9RUA6QMeta } from "/opt/apps/transkribus_app_beta/pages/models/admin-slugs.vue?macro=true";
import { default as indexB97r869w2MtOsaOH6w_3Z8D3OZqAZs3kgCfkTuotXn0Meta } from "/opt/apps/transkribus_app_beta/pages/share/[hash]/index.vue?macro=true";
import { default as overviewM_ZlccqXUWJe0RsMy902unXnY2fJXAuPzdMi6ikBPpoMeta } from "/opt/apps/transkribus_app_beta/pages/collection/overview.vue?macro=true";
import { default as index_sYFWgEL9QbSritCyElWm4JlOeptpkixLnx_hfv7T0UMeta } from "/opt/apps/transkribus_app_beta/pages/datasets/[id]/index.vue?macro=true";
import { default as indexlIQeVqrwRp4vGyGmMITjnRZhkMC2sEFVskJcZv4LwggMeta } from "/opt/apps/transkribus_app_beta/pages/models/public/index.vue?macro=true";
import { default as indexv3WZ3RdQIcafiKyd7Sc7oFBvE_Q22o_gzObpFkqVQ2MMeta } from "/opt/apps/transkribus_app_beta/pages/notifications/index.vue?macro=true";
import { default as indexs1Y_8G_kZFjUJc7b0IL_YT4iV70e6bRmq_hzLH6HdAoMeta } from "/opt/apps/transkribus_app_beta/pages/projects/[id]/index.vue?macro=true";
import { default as indexVD7kXCT_Yw25NNq1oWOBjuPXLVknetbR4xwpu5t7mX0Meta } from "/opt/apps/transkribus_app_beta/pages/public-models/index.vue?macro=true";
import { default as indexJCBGYVkDEp5d58nhclBpeZpauekLRxRvMxLLroVhb0IMeta } from "/opt/apps/transkribus_app_beta/pages/user-settings/index.vue?macro=true";
import { default as indexuwqNIHpNehRyxk__M7LL06OKAKZoN94p3qUhARXkvOAMeta } from "/opt/apps/transkribus_app_beta/pages/data-lab/train/index.vue?macro=true";
import { default as indexDI1R8idu97bDWmh9dRVRv9iuFw_asGwfSwrnKlWqgk4Meta } from "/opt/apps/transkribus_app_beta/pages/activity/hermes/index.vue?macro=true";
import { default as indexlayFthumUqehnHU6gnjAki2K5X25u4UWKB_vxWbu3HwMeta } from "/opt/apps/transkribus_app_beta/pages/datasets/create/index.vue?macro=true";
import { default as indexDFJgft1hOaSZkZen_oefcGAdtkTTxmoJnM6ol1BGGqYMeta } from "/opt/apps/transkribus_app_beta/pages/projects/create/index.vue?macro=true";
import { default as indexkIzZVa2X1BRE5sj6IzQWM9X_dpezZdIkaexOicvhBdQMeta } from "/opt/apps/transkribus_app_beta/pages/quality-control/index.vue?macro=true";
import { default as indexC_2rFc9Fw1_w6QcEF9z2qGyqFwhPr2hKzF_ifNiyZWgMeta } from "/opt/apps/transkribus_app_beta/pages/sites/[url]/tags/index.vue?macro=true";
import { default as index50KwYTXT23bg9zhJtf9QHECzZ5BAOVmtZ0p_0kYmFoYMeta } from "/opt/apps/transkribus_app_beta/pages/activity/advanced/index.vue?macro=true";
import { default as indexq2bRMkGbBT6H01OkH2muegRSO_DTRBDojmgU0UcMu2MMeta } from "/opt/apps/transkribus_app_beta/pages/sites/[url]/about/index.vue?macro=true";
import { default as _91_46_46_46path_93oJhkWMLoYHj0LTTF4O0AYokuHYPiy71eZMSLacDqRnYMeta } from "/opt/apps/transkribus_app_beta/pages/[locale]/sites/[...path].vue?macro=true";
import { default as indexCZjINkbdySanOyY1QwntIh9p67IL5WP9PPJmWfxI3ggMeta } from "/opt/apps/transkribus_app_beta/pages/datasets/[id]/data/index.vue?macro=true";
import { default as indextdK45NGugD3khyXhsXPKwhpsMoEsKfAhPuUMaql8z10Meta } from "/opt/apps/transkribus_app_beta/pages/sites/[url]/browse/index.vue?macro=true";
import { default as indexahbYwanA0MIHM33u4mPdQYiYbjCSwtsokPa7keKp9IwMeta } from "/opt/apps/transkribus_app_beta/pages/sites/[url]/search/index.vue?macro=true";
import { default as indexrdWu6fN880FA_09TwEXBpddcnR1aO_S7tvodSCYhTNQMeta } from "/opt/apps/transkribus_app_beta/pages/collection-settings/index.vue?macro=true";
import { default as index8SRz4i7nu9gbLyb5JBNjDVvcMXOvWXaPlKUsZ8qaXmYMeta } from "/opt/apps/transkribus_app_beta/pages/sites/[url]/imprint/index.vue?macro=true";
import { default as index2qXK4I40evZEdBMmlcTOB_efnwjgWM0SeqL4HTQyZcUMeta } from "/opt/apps/transkribus_app_beta/pages/activity/recognition/index.vue?macro=true";
import { default as indexwYW1lYPzftEjDf4Ctp5T1C08atSqKwpiEA6QCrIL6isMeta } from "/opt/apps/transkribus_app_beta/pages/activity/up-download/index.vue?macro=true";
import { default as index5XurYmxzdZMeW55QPyECH349C5x3pJqNFYEfirDA9h0Meta } from "/opt/apps/transkribus_app_beta/pages/datasets/[id]/manage/index.vue?macro=true";
import { default as indexT4q6xboREmRe_Pu6iTq1m_fy9Fx4_gZSO7ov1QJgDqkMeta } from "/opt/apps/transkribus_app_beta/pages/projects/[id]/manage/index.vue?macro=true";
import { default as indexyxSiHrpxTCxRE6O9kNRgInKcul6Uyg_f09hs_j_H4ToMeta } from "/opt/apps/transkribus_app_beta/pages/invitations/[inviteid]/index.vue?macro=true";
import { default as indexqBaYTHqqOIvoqsI_LgQoHOQWs_kbNV_LbVRqPaZ26_YMeta } from "/opt/apps/transkribus_app_beta/pages/models/[type]/[modelId]/index.vue?macro=true";
import { default as indexzO5C_RydAgGP0fzAm725csEPGBNbI5NhjfROVpDU_A4Meta } from "/opt/apps/transkribus_app_beta/pages/sites/[url]/doc/[docid]/index.vue?macro=true";
import { default as index0cJNQPGQge5DxH2hjNJOE4Bq1p6t9gbMhWRCo88OO_kMeta } from "/opt/apps/transkribus_app_beta/pages/collection/[collectionid]/index.vue?macro=true";
import { default as indexuR2N0YNnEhhO9dVhFFFQWwmZi8UwclVrdoHb4mi6DgoMeta } from "/opt/apps/transkribus_app_beta/pages/models/[type]/[modelId]/modify/index.vue?macro=true";
import { default as indexu1SRV14u3zqhgJ4_Hx0Iw41QJMeAInGctWKDUay6e7wMeta } from "/opt/apps/transkribus_app_beta/pages/models/public/[type]/[modelId]/index.vue?macro=true";
import { default as indexA06N2zFEJo5wBZBq0vOCGLrRq5ckZdNJ39nUrsq83dkMeta } from "/opt/apps/transkribus_app_beta/pages/sites/[url]/doc/[docid]/detail/index.vue?macro=true";
import { default as indexrBdl9SE6VS4a2_CTv9VRTx8EcjnN8HkOG1sGETkV85QMeta } from "/opt/apps/transkribus_app_beta/pages/quality-control/sample/[sampleid]/index.vue?macro=true";
import { default as indexO_uESxi0iYfmYsibkqURMTyALo6l4sGhkOwUNqos2joMeta } from "/opt/apps/transkribus_app_beta/pages/sites/[url]/content/[contentName]/index.vue?macro=true";
import { default as indexuLxx95kMf_f0MWw7FhdXciisuoqXrUJiqq7Jgh5Xo5EMeta } from "/opt/apps/transkribus_app_beta/pages/models/[type]/[modelId]/train-data/index.vue?macro=true";
import { default as index6lOHMEIc11x6ePgAVHSqecYCwT_xs81eX2kSKJx4r_0Meta } from "/opt/apps/transkribus_app_beta/pages/collection/[collectionid]/doc/[docid]/index.vue?macro=true";
import { default as indexL_2o2t6_bcuqAf1dsCN7yN7LLLgoSgg9g_DqrDHuzMMMeta } from "/opt/apps/transkribus_app_beta/pages/sites/[url]/doc/[docid]/detail/[pageid]/index.vue?macro=true";
import { default as index36Gvqw6P6BDoBwCm8ER7O1n0RKXS4Mo_ezdNwwaS5XgMeta } from "/opt/apps/transkribus_app_beta/pages/collection/[collectionid]/doc/[docid]/edit/index.vue?macro=true";
import { default as indexnatMBJn7Ll50_V7ObkMMlaOGmXJUGjSBJqxf8lOyMhEMeta } from "/opt/apps/transkribus_app_beta/pages/usage/manage-organisation/[organisationid]/index.vue?macro=true";
import { default as indexAN5_f_GvhnbpZwkpkgXYyvBjXvQbUchen4z5_8lMFJEMeta } from "/opt/apps/transkribus_app_beta/pages/collection/[collectionid]/doc/[docid]/edit/[pageid]/index.vue?macro=true";
import { default as indexrPjcMwn9YkF0yPR3Q5YvNobaJ3ja8trvGDGuQdVUl_YMeta } from "/opt/apps/transkribus_app_beta/pages/collection/[collectionid]/doc/[docid]/detail/[pageid]/index.vue?macro=true";
import { default as indexgOWYJT7jDznn1tFQpa5RL__t_xUuOnqAnTjrJjEI3_QMeta } from "/opt/apps/transkribus_app_beta/pages/quality-control/sample/[sampleid]/evaluation/[evaluationid]/index.vue?macro=true";
import { default as indexKlSZxSvOIMvQLBZHY1Y4iJ3PO7TKtgP0f_h3nhSzzhYMeta } from "/opt/apps/transkribus_app_beta/pages/quality-control/sample/[sampleid]/evaluation/[evaluationid]/results/index.vue?macro=true";
import { default as indexrqu_llSHmMBktDXu4jpE2tlr8jCtgzNFnVa9scQF6o4Meta } from "/opt/apps/transkribus_app_beta/pages/quality-control/sample/[sampleid]/evaluation/[evaluationid]/page/[pageid]/index.vue?macro=true";
import { default as component_45stubg7XgebtTTJwtZGPtJUp19IKhMRXAEVvt5M9PXxJaHlgMeta } from "/opt/apps/transkribus_app_beta/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubg7XgebtTTJwtZGPtJUp19IKhMRXAEVvt5M9PXxJaHlg } from "/opt/apps/transkribus_app_beta/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "build",
    path: "/build",
    meta: { ...(build0lCHodXmJjSx8gfrpjHl6J8l_jpUw3TCU5_F8c4GIHYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/build.vue")
  },
  {
    name: "guide",
    path: "/guide",
    component: () => import("/opt/apps/transkribus_app_beta/pages/guide.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexfSDzduOPa653ICfdhPk_KHPbRPgrvDW2qcaVye9W16YMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(login8LO5ET6UGov1saxNYLsmkvzVrT0srajZZ6ryMiUkxt0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/login.vue")
  },
  {
    name: "changelog",
    path: "/changelog",
    meta: { ...(changelog7owxKjZgIRKXciyXGubOVpQCA3WPqrdvWMtLn9gJ9A4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/changelog.vue")
  },
  {
    name: "sites-map",
    path: "/sites/map",
    meta: { ...(map3yj0thrqZWsqNc9CkOiVTQKF1QPuOMpaTt7tBJdnIoEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/sites/map.vue")
  },
  {
    name: "jobs",
    path: "/jobs",
    meta: { ...(indexMFRmy3hCtp04_H6VifkeKG2KvpZuhnsEK_oPZz_7Z2oMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/jobs/index.vue")
  },
  {
    name: "learn",
    path: "/learn",
    meta: { ...(indexGxFG_0znRyzW1065yTwbwBeSNhA7kwcyNNLCKhMn5ggMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/learn/index.vue")
  },
  {
    name: "sites",
    path: "/sites",
    meta: { ...(indexLwl5ztTjrBMum4Oe0iFZ6a2EjyRHGm6was6wER8z14kMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/sites/index.vue")
  },
  {
    name: "usage",
    path: "/usage",
    meta: { ...(indexDjatYhnlnsRYn7ql_mnqmQNJppV_sGEpJUAIAs87bfIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/usage/index.vue")
  },
  {
    name: "models",
    path: "/models",
    meta: { ...(indexazCZd_1rdVm2YsN9UXz1Ab6QLOFpEYWevo8sr7keI4cMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/models/index.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: { ...(indexS4q9sapgMfWYn0HV03HUyIDbC7aNrl9mDrmhLARBHAUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/search/index.vue")
  },
  {
    name: "sites-create",
    path: "/sites/create",
    meta: { ...(create5FNN3tw6yUYQYkW91M1pOLvU97iD9DN68U8zwi_BRh0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/sites/create.vue")
  },
  {
    name: "upload",
    path: "/upload",
    meta: { ...(indexjedlQIF37A5hQLzsyI5Y5Ea3CcQSHzOMB3Ats1FQvb8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/upload/index.vue")
  },
  {
    name: "version",
    path: "/version",
    component: () => import("/opt/apps/transkribus_app_beta/pages/version/index.vue")
  },
  {
    name: "welcome",
    path: "/welcome",
    meta: {"middleware":"auth"},
    component: () => import("/opt/apps/transkribus_app_beta/pages/welcome/index.vue")
  },
  {
    name: "data-lab",
    path: "/data-lab",
    meta: { ...(indexBaJiRAzJZXS3qeBHqc193TiQL4M5ZtDHnH5QTIxMl6cMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/data-lab/index.vue")
  },
  {
    name: "datasets",
    path: "/datasets",
    meta: { ...(indexOVE7BDFuc6bZ1iPXH23U_6OWUtZd8FUeC_MRGegvwaoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/datasets/index.vue")
  },
  {
    name: "projects",
    path: "/projects",
    meta: { ...(indexJLjU4hD7rw89FYFJSKAlLjBYmwGP8cnUA8Obrinkr_MMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/projects/index.vue")
  },
  {
    name: "collection",
    path: "/collection",
    meta: { ...(indexFRnpCciRCOlNJngOgnEIAh_eKwKLpjaJobXyO0kFqb0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/collection/index.vue")
  },
  {
    name: "invitations",
    path: "/invitations",
    meta: { ...(indexvODCCl1VhMpQmRq67m57uno_I6qMDjSZOWcckMPcRmoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/invitations/index.vue")
  },
  {
    name: "sites-url",
    path: "/sites/:url()",
    meta: indexDOO9PmWFRjDTPJVpwbWnQsHmnOZe5i9dv_FvuRfd_EsMeta || {},
    component: () => import("/opt/apps/transkribus_app_beta/pages/sites/[url]/index.vue")
  },
  {
    name: "activity-all",
    path: "/activity/all",
    meta: { ...(index0bPy4prxDNEwJMvIsUqY3HLdkdZ5VJZSyQiJ35_J0fUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/activity/all/index.vue")
  },
  {
    name: "models-admin-slugs",
    path: "/models/admin-slugs",
    meta: { ...(admin_45slugsstvhNIdAfGhstG0g04KIbW1RQDcRSq3hOgFRl9RUA6QMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/models/admin-slugs.vue")
  },
  {
    name: "share-hash",
    path: "/share/:hash()",
    meta: indexB97r869w2MtOsaOH6w_3Z8D3OZqAZs3kgCfkTuotXn0Meta || {},
    component: () => import("/opt/apps/transkribus_app_beta/pages/share/[hash]/index.vue")
  },
  {
    name: "collection-overview",
    path: "/collection/overview",
    meta: { ...(overviewM_ZlccqXUWJe0RsMy902unXnY2fJXAuPzdMi6ikBPpoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/collection/overview.vue")
  },
  {
    name: "datasets-id",
    path: "/datasets/:id()",
    meta: { ...(index_sYFWgEL9QbSritCyElWm4JlOeptpkixLnx_hfv7T0UMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/datasets/[id]/index.vue")
  },
  {
    name: "models-public",
    path: "/models/public",
    component: () => import("/opt/apps/transkribus_app_beta/pages/models/public/index.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: { ...(indexv3WZ3RdQIcafiKyd7Sc7oFBvE_Q22o_gzObpFkqVQ2MMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/notifications/index.vue")
  },
  {
    name: "projects-id",
    path: "/projects/:id()",
    meta: { ...(indexs1Y_8G_kZFjUJc7b0IL_YT4iV70e6bRmq_hzLH6HdAoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/projects/[id]/index.vue")
  },
  {
    name: "public-models",
    path: "/public-models",
    meta: indexVD7kXCT_Yw25NNq1oWOBjuPXLVknetbR4xwpu5t7mX0Meta || {},
    component: () => import("/opt/apps/transkribus_app_beta/pages/public-models/index.vue")
  },
  {
    name: "user-settings",
    path: "/user-settings",
    meta: { ...(indexJCBGYVkDEp5d58nhclBpeZpauekLRxRvMxLLroVhb0IMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/user-settings/index.vue")
  },
  {
    name: "data-lab-train",
    path: "/data-lab/train",
    meta: { ...(indexuwqNIHpNehRyxk__M7LL06OKAKZoN94p3qUhARXkvOAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/data-lab/train/index.vue")
  },
  {
    name: "activity-hermes",
    path: "/activity/hermes",
    meta: { ...(indexDI1R8idu97bDWmh9dRVRv9iuFw_asGwfSwrnKlWqgk4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/activity/hermes/index.vue")
  },
  {
    name: "datasets-create",
    path: "/datasets/create",
    meta: { ...(indexlayFthumUqehnHU6gnjAki2K5X25u4UWKB_vxWbu3HwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/datasets/create/index.vue")
  },
  {
    name: "projects-create",
    path: "/projects/create",
    meta: { ...(indexDFJgft1hOaSZkZen_oefcGAdtkTTxmoJnM6ol1BGGqYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/projects/create/index.vue")
  },
  {
    name: "quality-control",
    path: "/quality-control",
    meta: { ...(indexkIzZVa2X1BRE5sj6IzQWM9X_dpezZdIkaexOicvhBdQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/quality-control/index.vue")
  },
  {
    name: "sites-url-tags",
    path: "/sites/:url()/tags",
    meta: indexC_2rFc9Fw1_w6QcEF9z2qGyqFwhPr2hKzF_ifNiyZWgMeta || {},
    component: () => import("/opt/apps/transkribus_app_beta/pages/sites/[url]/tags/index.vue")
  },
  {
    name: "activity-advanced",
    path: "/activity/advanced",
    meta: { ...(index50KwYTXT23bg9zhJtf9QHECzZ5BAOVmtZ0p_0kYmFoYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/activity/advanced/index.vue")
  },
  {
    name: "sites-url-about",
    path: "/sites/:url()/about",
    meta: indexq2bRMkGbBT6H01OkH2muegRSO_DTRBDojmgU0UcMu2MMeta || {},
    component: () => import("/opt/apps/transkribus_app_beta/pages/sites/[url]/about/index.vue")
  },
  {
    name: "locale-sites-path",
    path: "/:locale()/sites/:path(.*)*",
    component: () => import("/opt/apps/transkribus_app_beta/pages/[locale]/sites/[...path].vue")
  },
  {
    name: "datasets-id-data",
    path: "/datasets/:id()/data",
    meta: { ...(indexCZjINkbdySanOyY1QwntIh9p67IL5WP9PPJmWfxI3ggMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/datasets/[id]/data/index.vue")
  },
  {
    name: "sites-url-browse",
    path: "/sites/:url()/browse",
    meta: indextdK45NGugD3khyXhsXPKwhpsMoEsKfAhPuUMaql8z10Meta || {},
    component: () => import("/opt/apps/transkribus_app_beta/pages/sites/[url]/browse/index.vue")
  },
  {
    name: "sites-url-search",
    path: "/sites/:url()/search",
    meta: indexahbYwanA0MIHM33u4mPdQYiYbjCSwtsokPa7keKp9IwMeta || {},
    component: () => import("/opt/apps/transkribus_app_beta/pages/sites/[url]/search/index.vue")
  },
  {
    name: "collection-settings",
    path: "/collection-settings",
    meta: { ...(indexrdWu6fN880FA_09TwEXBpddcnR1aO_S7tvodSCYhTNQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/collection-settings/index.vue")
  },
  {
    name: "sites-url-imprint",
    path: "/sites/:url()/imprint",
    meta: index8SRz4i7nu9gbLyb5JBNjDVvcMXOvWXaPlKUsZ8qaXmYMeta || {},
    component: () => import("/opt/apps/transkribus_app_beta/pages/sites/[url]/imprint/index.vue")
  },
  {
    name: "activity-recognition",
    path: "/activity/recognition",
    meta: { ...(index2qXK4I40evZEdBMmlcTOB_efnwjgWM0SeqL4HTQyZcUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/activity/recognition/index.vue")
  },
  {
    name: "activity-up-download",
    path: "/activity/up-download",
    meta: { ...(indexwYW1lYPzftEjDf4Ctp5T1C08atSqKwpiEA6QCrIL6isMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/activity/up-download/index.vue")
  },
  {
    name: "datasets-id-manage",
    path: "/datasets/:id()/manage",
    meta: { ...(index5XurYmxzdZMeW55QPyECH349C5x3pJqNFYEfirDA9h0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/datasets/[id]/manage/index.vue")
  },
  {
    name: "projects-id-manage",
    path: "/projects/:id()/manage",
    meta: { ...(indexT4q6xboREmRe_Pu6iTq1m_fy9Fx4_gZSO7ov1QJgDqkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/projects/[id]/manage/index.vue")
  },
  {
    name: "invitations-inviteid",
    path: "/invitations/:inviteid()",
    meta: { ...(indexyxSiHrpxTCxRE6O9kNRgInKcul6Uyg_f09hs_j_H4ToMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/invitations/[inviteid]/index.vue")
  },
  {
    name: "models-type-modelId",
    path: "/models/:type()/:modelId()",
    meta: { ...(indexqBaYTHqqOIvoqsI_LgQoHOQWs_kbNV_LbVRqPaZ26_YMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/models/[type]/[modelId]/index.vue")
  },
  {
    name: "sites-url-doc-docid",
    path: "/sites/:url()/doc/:docid()",
    meta: indexzO5C_RydAgGP0fzAm725csEPGBNbI5NhjfROVpDU_A4Meta || {},
    component: () => import("/opt/apps/transkribus_app_beta/pages/sites/[url]/doc/[docid]/index.vue")
  },
  {
    name: "collection-collectionid",
    path: "/collection/:collectionid()",
    meta: { ...(index0cJNQPGQge5DxH2hjNJOE4Bq1p6t9gbMhWRCo88OO_kMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/collection/[collectionid]/index.vue")
  },
  {
    name: "models-type-modelId-modify",
    path: "/models/:type()/:modelId()/modify",
    meta: { ...(indexuR2N0YNnEhhO9dVhFFFQWwmZi8UwclVrdoHb4mi6DgoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/models/[type]/[modelId]/modify/index.vue")
  },
  {
    name: "models-public-type-modelId",
    path: "/models/public/:type()/:modelId()",
    component: () => import("/opt/apps/transkribus_app_beta/pages/models/public/[type]/[modelId]/index.vue")
  },
  {
    name: "sites-url-doc-docid-detail",
    path: "/sites/:url()/doc/:docid()/detail",
    meta: indexA06N2zFEJo5wBZBq0vOCGLrRq5ckZdNJ39nUrsq83dkMeta || {},
    component: () => import("/opt/apps/transkribus_app_beta/pages/sites/[url]/doc/[docid]/detail/index.vue")
  },
  {
    name: "quality-control-sample-sampleid",
    path: "/quality-control/sample/:sampleid()",
    meta: { ...(indexrBdl9SE6VS4a2_CTv9VRTx8EcjnN8HkOG1sGETkV85QMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/quality-control/sample/[sampleid]/index.vue")
  },
  {
    name: "sites-url-content-contentName",
    path: "/sites/:url()/content/:contentName()",
    meta: indexO_uESxi0iYfmYsibkqURMTyALo6l4sGhkOwUNqos2joMeta || {},
    component: () => import("/opt/apps/transkribus_app_beta/pages/sites/[url]/content/[contentName]/index.vue")
  },
  {
    name: "models-type-modelId-train-data",
    path: "/models/:type()/:modelId()/train-data",
    meta: { ...(indexuLxx95kMf_f0MWw7FhdXciisuoqXrUJiqq7Jgh5Xo5EMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/models/[type]/[modelId]/train-data/index.vue")
  },
  {
    name: "collection-collectionid-doc-docid",
    path: "/collection/:collectionid()/doc/:docid()",
    meta: { ...(index6lOHMEIc11x6ePgAVHSqecYCwT_xs81eX2kSKJx4r_0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/collection/[collectionid]/doc/[docid]/index.vue")
  },
  {
    name: "sites-url-doc-docid-detail-pageid",
    path: "/sites/:url()/doc/:docid()/detail/:pageid()",
    component: () => import("/opt/apps/transkribus_app_beta/pages/sites/[url]/doc/[docid]/detail/[pageid]/index.vue")
  },
  {
    name: "collection-collectionid-doc-docid-edit",
    path: "/collection/:collectionid()/doc/:docid()/edit",
    meta: { ...(index36Gvqw6P6BDoBwCm8ER7O1n0RKXS4Mo_ezdNwwaS5XgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/collection/[collectionid]/doc/[docid]/edit/index.vue")
  },
  {
    name: "usage-manage-organisation-organisationid",
    path: "/usage/manage-organisation/:organisationid()",
    meta: { ...(indexnatMBJn7Ll50_V7ObkMMlaOGmXJUGjSBJqxf8lOyMhEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/usage/manage-organisation/[organisationid]/index.vue")
  },
  {
    name: "collection-collectionid-doc-docid-edit-pageid",
    path: "/collection/:collectionid()/doc/:docid()/edit/:pageid()",
    component: () => import("/opt/apps/transkribus_app_beta/pages/collection/[collectionid]/doc/[docid]/edit/[pageid]/index.vue")
  },
  {
    name: "collection-collectionid-doc-docid-detail-pageid",
    path: "/collection/:collectionid()/doc/:docid()/detail/:pageid()",
    component: () => import("/opt/apps/transkribus_app_beta/pages/collection/[collectionid]/doc/[docid]/detail/[pageid]/index.vue")
  },
  {
    name: "quality-control-sample-sampleid-evaluation-evaluationid",
    path: "/quality-control/sample/:sampleid()/evaluation/:evaluationid()",
    component: () => import("/opt/apps/transkribus_app_beta/pages/quality-control/sample/[sampleid]/evaluation/[evaluationid]/index.vue")
  },
  {
    name: "quality-control-sample-sampleid-evaluation-evaluationid-results",
    path: "/quality-control/sample/:sampleid()/evaluation/:evaluationid()/results",
    meta: { ...(indexKlSZxSvOIMvQLBZHY1Y4iJ3PO7TKtgP0f_h3nhSzzhYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/quality-control/sample/[sampleid]/evaluation/[evaluationid]/results/index.vue")
  },
  {
    name: "quality-control-sample-sampleid-evaluation-evaluationid-page-pageid",
    path: "/quality-control/sample/:sampleid()/evaluation/:evaluationid()/page/:pageid()",
    meta: { ...(indexrqu_llSHmMBktDXu4jpE2tlr8jCtgzNFnVa9scQF6o4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/pages/quality-control/sample/[sampleid]/evaluation/[evaluationid]/page/[pageid]/index.vue")
  },
  {
    name: component_45stubg7XgebtTTJwtZGPtJUp19IKhMRXAEVvt5M9PXxJaHlgMeta?.name,
    path: "/home",
    component: component_45stubg7XgebtTTJwtZGPtJUp19IKhMRXAEVvt5M9PXxJaHlg
  },
  {
    name: component_45stubg7XgebtTTJwtZGPtJUp19IKhMRXAEVvt5M9PXxJaHlgMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubg7XgebtTTJwtZGPtJUp19IKhMRXAEVvt5M9PXxJaHlg
  }
]